import React from "react";
import Profile from "../Profile/Components/profile-component";

function BasicInfo() {
  return (
    <div className="container">
      <div className="Basic-Info">
        <div class="linee">
          <a class="dot" href="">
            ...
          </a>{" "}
        </div>

        <div className="overflow7">
          <form className="form2">
            <label for="firstName" className="basic-info-heading">
              First Name
            </label>
            <br></br>
            <input
              type="text "
              required="true"
              class="basicInfo"
              size="55"
              name="firstName"
              id="companyName"
              maxlength="20"
              placeholder="First Name"
            />
            <br></br>
            <label for="lastname" className="basic-info-heading">
              Last Name
            </label>
            <br></br>

            <input
              type="text "
              required="true"
              class="basicInfo"
              name="lastname"
              size="55"
              id="lastname"
              placeholder="Last Name"
            />
            <br></br>
            <label for="companyName" className="basic-info-heading">
              Company Name
            </label>
            <br></br>
            <input
              type="text"
              raquired="true"
              class="basicInfo"
              name="companyName"
              size="55"
              id="companyName"
              placeholder="Company Name"
            />
            <br></br>
            <label className="basic-info-heading">E-mail address</label>
            <br></br>
            <input
              type="email"
              required="true"
              class="basicInfo"
              placeholder="mo*******@gmail.com"
              name="email"
              size="55"
              id="email"
            />
            <br></br>
            <label for="phone" className="basic-info-heading">
              Phone Number
            </label>
            <br></br>
            <input
              type="tel"
              required="true"
              class="basicInfo"
              placeholder="+91-988*******"
              name="phone"
              size="55"
              id="phone"
            />
            <br></br>
          </form>
        </div>
        <div className="overflow8">
          <form className="form1">
            <label for="firstName" className="basic-info-heading">
              First Name
            </label>
            <br></br>
            <input
              type="text "
              required="true"
              class="basicInfo"
              size="55"
              name="firstName"
              id="companyName"
              maxlength="20"
              placeholder="First Name"
            />
            <br></br>
            <label for="lastname" className="basic-info-heading">
              Last Name
            </label>
            <br></br>

            <input
              type="text "
              required="true"
              class="basicInfo"
              name="lastname"
              size="55"
              id="lastname"
              placeholder="Last Name"
            />
            <br></br>
            <label for="companyName" className="basic-info-heading">
              Company Name
            </label>
            <br></br>
            <input
              type="text"
              raquired="true"
              class="basicInfo"
              name="companyName"
              size="55"
              id="companyName"
              placeholder="Company Name"
            />
            <br></br>
            <label className="basic-info-heading">E-mail address</label>
            <br></br>
            <input
              type="email"
              required="true"
              class="basicInfo"
              placeholder="mo*******@gmail.com"
              name="email"
              size="55"
              id="email"
            />
            <br></br>
          </form>
        </div>
        <center>
          {" "}
          <button type="submit" class="basic-btn">
            Save
          </button>
          <br></br>
          <p class="data2">Your data will be updated on directory ASAP</p>
        </center>
        <div class="line0">
          <p className="acc">Account details</p>
        </div>
      </div>
    </div>
  );
}
export default BasicInfo;
